export const Flight = {
  ROUNDTRIP: 'roundTrip',
  ONEWAY: 'oneWay',
  MULTICITY: 'multiCity',
} as const;

export type FlightValue = (typeof Flight)[keyof typeof Flight];
